var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-img',{staticStyle:{"margin":"0 auto"},attrs:{"width":"60%","src":require('@/assets/404.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }